import React from 'react';
import { useRoutes } from "react-router-dom";
import { ExternalRedirect } from "./components/ExternalRedirect";
// import Loadable from "./components/Loadable";

// import SimpleLayout from "./layout/SimpleLayout";
import RegisterAddress from "./components/Register/Address";
import RegisterOwner from "./components/Register/Owner";
import RegisterCarwash from "./components/Register/Carwash";
import RegisterService from "./components/Register/Service";
import RegisterSignUp from "./components/Register/SignUp";
import RegisterConfirmation from "./components/Register/Confirmation";
import RegisterAnalysis from "./components/Register/Analysis";
import RegisterCategorySelection from "./components/Register/CategorySelection";
import RegisterExplanation from "./components/Register/Explanation";
import SurveyPage from "./components/Register/SurveyPage";
import ClienteLP from "./components/LandingPages/Cliente";
import ParceirosLP from "./components/LandingPages/Parceiros";
import ClienteLPSuccess from "./components/LandingPages/Cliente/Sucesso";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ClientPrivacyPolicy from "./pages/PrivacyPolicy/clientPrivacyPolicy";
import AppDownload from "./pages/AppDownload/app-download";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import Planos from "./pages/Planos";
import Profissional from "./pages/Profissional";
import PaymentConfirmation from "./pages/PaymentConfirmation/payment-confirmation";
import Checkout from "./pages/Checkout";
import TermsAndConditions from "./pages/TermsAndConditions";
import { DoutorMonitoraLP } from "./pages/DoutorMonitora";
import MapaParceiros from "./pages/MapaParceiros";
import VitrinePage from "./pages/VitrinePage";
import ServicoDetalhePage from "./pages/ServicoDetalhePage";

// const Login = Loadable(React.lazy(() => import("./components/Login/Login")));
// const SignUp = Loadable(React.lazy(() => import("./components/SignUp/SignUp")));

const MainRoutes = {
  path: "/",
  element: <Home />,
};

const SupportRoutes = {
  path: "/",
  children: [
    {
      path: "/privacy-policy",
      element: <PrivacyPolicy />,
    },
    {
      path: "/client-privacy-policy",
      element: <ClientPrivacyPolicy />,
    },
    {
      path: "/app-download",
      element: <AppDownload />,
    },
    {
      path: "/fale-conosco",
      element: <Contact />,
    },
    {
      path: "/checkout",
      element: <Checkout />,
    },
    {
      path: "/assinatura-confirmada",
      element: <PaymentConfirmation />,
    },
    {
      path: '/assinatura-profissional-confirmada',
      element: <PaymentConfirmation />
    },
    {
      path: '/termos-e-condicoes',
      element: <TermsAndConditions />,
    },
  ],
};

/* const LoginRoutes = {
  path: "/",
  element: <SimpleLayout />,
  children: [
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/signup",
      element: <SignUp />,
    },
  ],
}; */

const RegisterRoutes = {
  path: "register",
  children: [
    {
      path: "/register/address",
      element: <RegisterAddress />,
    },
    {
      path: "/register/owner",
      element: <RegisterOwner />,
    },
    {
      path: "/register/carwash",
      element: <RegisterCarwash />,
    },
    {
      path: "/register/explanation",
      element: <RegisterExplanation />,
    },
    {
      path: "/register/survey",
      element: <SurveyPage />,
    },
    {
      path: "/register/category",
      element: <RegisterCategorySelection />,
    },
    {
      path: "/register/service",
      element: <RegisterService />,
    },
    {
      path: "/register/signup",
      element: <RegisterSignUp />,
    },
    {
      path: "/register/confirmation",
      element: <RegisterConfirmation />,
    },
    {
      path: "/register/analysis",
      element: <RegisterAnalysis />,
    },
  ],
};

const LPs = {
  path: "/",
  children: [
    {
      path: "/clientes-old",
      element: <ClienteLP />,
    },
    {
      path: "/clientes/sucesso",
      element: <ClienteLPSuccess />,
    },
    {
      path: "/parceiros",
      element: <ParceirosLP />,
    },
    {
      path: "/clientes",
      element: <ExternalRedirect to="https://assine.wash.app.br/clientes/" />,
    },
    {
      path: "/profissional",
      element: <Profissional />,
    },
    {
      path: "/drmonitora",
      element: <DoutorMonitoraLP />,
    },
    {
      path: "/mapa-parceiros",
      element: <MapaParceiros />,
    },
    {
      path: "/vitrine",
      element: <VitrinePage />,
    },
    {
      path: "/vitrine/:serviceId",
      element: <ServicoDetalhePage />,
    },
  ],
};

export default function ThemeRoutes() {
  return useRoutes([
    MainRoutes,
    // LoginRoutes,
    RegisterRoutes,
    LPs,
    SupportRoutes,
  ]);
}
